// extracted by mini-css-extract-plugin
module.exports = {"upload_des":"UploadImg_style_upload_des__23BGI","upload_add":"UploadImg_style_upload_add__10s0d"};